import { Component, Input, OnInit } from '@angular/core';
import { LanguageService } from '@ibank-globals/language';
import { AppSettings } from '../../app.settings';
import { BaseComponent } from '../../../globals/classes/base.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { DataInfoComponent } from '../data-info/data-info.component';

@Component({
	selector: 'login-header',
	template: require('./login-header.component.html'),
})
export class LoginHeaderComponent extends BaseComponent implements OnInit {
	public isEnglish: boolean;
	public showPopUp = true;
	public multilanguage = AppSettings.multilanguage;
	@Input() hasGreenBg: boolean = false;
	@Input() hasTitle: boolean = false;
	@Input() title: string = 'Συχνές ερωτήσεις';
	@Input() isLogin: boolean = true;
	public isRebrading = AppSettings.isRebrading;
	selectedLanguage = 'ΕΛ';
	isExpanded = false;
	constructor(
		private _langSvc: LanguageService,
		private modalService: NgbModal,
		private router: Router,
		private activatedRoute: ActivatedRoute
	) {
		super();
	}

	public ngOnInit(): void {
		this._setupPopUp();
		this._initSubscriptions();
	}

	public toggleLanguage() {
		if (this.multilanguage === true) {
			this._langSvc.changeLanguage();
		}
	}

	toggleExpanded() {
		this.isExpanded = !this.isExpanded;
	}

	onClickOutside() {
		if (this.isExpanded) {
			this.isExpanded = !this.isExpanded;
		}
	}

	public selectLanguage(option: string): void {
		this.isExpanded = !this.isExpanded;
		switch (option) {
			case 'ΕΛ':
				this.selectedLanguage = 'ΕΛ';
				break;
			case 'EN':
				this.selectedLanguage = 'EN';
				break;
			default:
				break;
		}
	}

	public toggleDataModal() {
		this.modalService.open(DataInfoComponent, {
			windowClass: 'modal-small',
		});
	}

	private _setupPopUp() {
		setTimeout(() => {
			this.showPopUp = true;
			return;
		}, 2000);
		setTimeout(() => {
			this.showPopUp = false;
			return;
		}, 7000);
	}

	private _initSubscriptions() {
		this.mortalize(this._langSvc.activeLanguage$).subscribe((lang) => {
			this.isEnglish = lang === 'en';
		});
	}
}
